import styled from 'styled-components';
import { StyleColor, Format, BaseStyledComponentProps } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';
import { MenuPosition } from '../../typings/menu';

interface WrapperProps {
	position?: MenuPosition;
}

interface StyledButtonProps extends BaseStyledComponentProps {
	isActive: boolean;
}

const Wrapper = styled('div')`
	position: relative;
	margin: ${({ position }: WrapperProps) => position === MenuPosition.burger ? 0 : '0 10px'};

	> ul {
		max-height: 300px;
	}

	${({ position }: WrapperProps) => position === MenuPosition.burger
		? `
			> ul {
				left: 10px;
				width: calc(100% - 20px);
			}
		`
		: `
			> ul {
				left: ${position === MenuPosition.right ? 'auto' : '-32px'};
				right: ${position === MenuPosition.right ? 0 : 'auto'};
			}
		`
	}

	@media ${Format.Smartphone} {
		${({ position }: WrapperProps) => position !== MenuPosition.burger && `
			transform: scale(0.8) translateX(${position === MenuPosition.right ? '12%' : '-12%'});
		`}
	}
`;

const StyledButton = styled('button')`
	box-sizing: border-box;
	position: relative;
	padding: 10px 40px 10px 20px;
	border-radius: 20px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 18px;
	line-height: 20px;
	background-color: ${(props: StyledButtonProps) => props.isActive
		? `${hexToRgba(props.theme.primary.iconsColor, 20)}`
		: `${hexToRgba(props.theme.primary.topnavColor, 40)}`};
	color: ${(props: StyledButtonProps) => props.theme.primary.iconsColor};
	box-shadow: 0 0 1px 0 ${hexToRgba(StyleColor.Black, 29)},
				1px 2px 3px 0 ${hexToRgba(StyleColor.Black, 17)};
	cursor: pointer;

	&:hover {
		background-color: ${(props: StyledButtonProps) => hexToRgba(props.theme.primary.iconsColor, 20)};
	}

	&::before,
	&::after {
		content: '';
		position: absolute;
		top: 19px;
		right: 17px;
		width: 14px;
		height: 2px;
		background-color: currentColor;
	}

	&::after {
		transform: rotate(90deg);
	}
`;

export {
	Wrapper,
	StyledButton,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ButtonCreate/styles.ts